import { PLANS } from '@constants/plans'
import { formatNumericBasedOnLanguage } from '@helpers/data'
import { Trans } from 'react-i18next'

const {
  LITE_22,
  LITE_24,
  PROFESSIONAL_22,
  PROFESSIONAL_24,
  PROFESSIONAL_100K_23,
  PROFESSIONAL_200K_23,
  PROFESSIONAL_1M_23,
  PROFESSIONAL_500K_23,
  AGENCY_22,
  AGENCY_100K_23,
  AGENCY_200K_23,
  AGENCY_500K_23,
  AGENCY_1M_23,
  LITE_LIMITED_24,
  CORE_21,
  CREATE_21,
  AUTOMATE_21,
  AGENCY_21,
  ENTERPRISE_25
} = PLANS

export const getPlansLimits = (
  visitsTranslationKey:
    | 'change.plan.page.visits'
    | 'change.plan.page.visits.no.bold'
) => ({
  [LITE_22]: {
    domains: <Trans i18nKey='change.plan.page.domain' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.10.published.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(5000) }}
      />
    )
  },
  [LITE_LIMITED_24]: {
    domains: <Trans i18nKey='change.plan.page.domain' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.10.published.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(5000) }}
      />
    )
  },
  [LITE_24]: {
    domains: <Trans i18nKey='change.plan.page.domain' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.10.published.landing.pages.bolds' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(5000) }}
      />
    )
  },
  [PROFESSIONAL_22]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(50000) }}
      />
    )
  },
  [PROFESSIONAL_24]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(50000) }}
      />
    )
  },
  [PROFESSIONAL_100K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(100000) }}
      />
    )
  },
  [PROFESSIONAL_200K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(200000) }}
      />
    )
  },
  [PROFESSIONAL_500K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(500000) }}
      />
    )
  },
  [PROFESSIONAL_1M_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 10 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(1000000) }}
      />
    )
  },
  [AGENCY_22]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 20 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(50000) }}
      />
    )
  },
  [AGENCY_100K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 20 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(100000) }}
      />
    )
  },
  [AGENCY_200K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 20 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(200000) }}
      />
    )
  },
  [AGENCY_500K_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 20 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(500000) }}
      />
    )
  },
  [AGENCY_1M_23]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains.ssl' values={{ domains: 20 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(1000000) }}
      />
    )
  },
  [CORE_21]: {
    domains: <Trans i18nKey='change.plan.page.domain' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(1000) }}
      />
    )
  },
  [CREATE_21]: {
    domains: <Trans i18nKey='change.plan.page.two.custom.domains' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(20000) }}
      />
    )
  },
  [AUTOMATE_21]: {
    domains: <Trans i18nKey='change.plan.page.four.custom.domains' />,
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(40000) }}
      />
    )
  },
  [AGENCY_21]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains' values={{ domains: 5 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: (
      <Trans
        i18nKey={visitsTranslationKey}
        values={{ visits: formatNumericBasedOnLanguage(50000) }}
      />
    )
  },
  [ENTERPRISE_25]: {
    domains: (
      <Trans i18nKey='change.plan.page.domains' values={{ domains: 100 }} />
    ),
    landing_pages: (
      <Trans i18nKey='change.plan.page.unlimited.landing.pages.bold' />
    ),
    visits: <Trans i18nKey='change.plan.page.unlimited.visits.no.bold' />
  }
})

type PlansLimitsType = ReturnType<typeof getPlansLimits>

export type PlansLimitsKeys = keyof PlansLimitsType
